<template>
  <div class="form-group custom-form-group">
    <label v-if="displayLabel" class="custom-form-group-label" :for="id">{{ labelText }}</label>
    <span v-if="disclaimer" class="custom-form-group-disclaimer" v-html="disclaimer" />

    <input
      v-if="multiple"
      :name="name"
      type="hidden"
      value="">

    <select
      v-if="objectMethod"
      :id="id"
      :value="selected"
      :name="name"
      :multiple="multiple"
      :size="sizeOrDefault"
      :disabled="disabled"
      :required="required"
      class="custom-select custom-input"
      :class="{'custom-input-short': shortened}"
      @focus="setFocus()"
      @change="updateValue($event.target.options); $emit('change', $event)"
      @blur="$emit('blur', $event)">
      <option v-if="any" value="">
        {{ any }}
      </option>
      <option
        v-for="item in items"
        :key="item[keyMethod]"
        :selected="(item[valueMethod] === parseInt(selected))"
        :value="item[valueMethod]">
        {{ item[methodName] }}
      </option>
    </select>

    <select
      v-else
      :id="id"
      :value="selected"
      :name="name"
      :multiple="multiple"
      :size="sizeOrDefault"
      :disabled="disabled"
      :required="required"
      class="custom-select custom-input"
      :class="{'custom-input-short': shortened}"
      @change="updateValue($event.target.options); "
      @blur="$emit('blur', $event)">
      <option v-if="any" value="">
        {{ any }}
      </option>
      <option
        v-for="(item, index) in items"
        :key="item"
        :selected="(mappedValues(item, index) === selected)"
        :value="mappedValues(item, index)">
        {{ item }}
      </option>
    </select>
  </div>
</template>

<script>
import UIComponentMixin from "../../Mixins/UIComponentMixin";
import { humanize } from "../../helpers";

export default {
  name: "ItemSelect",

  mixins: [
    UIComponentMixin
  ],

  props: {
    items: { type: [Array, Number] },
    value: { type: [Array, String, Number, Boolean, Object] },
    defaultValue: { type: [Array, String, Number, Boolean],
      default: function () {
        return [];
      } },
    name: { type: String },
    label: { type: String },
    multiple: { type: Boolean, default: false },
    size: { type: String },
    disabled: Boolean,
    disclaimer: String,
    shortened: { type: Boolean, default: true },
    objectMethod: { type: Boolean, default: true },
    any: { type: String, default: "" },
    methodName: { type: String, default: "name" },
    keyMethod: { type: String, default: "id" },
    valueMethod: { type: String, default: "id" },
    valueMap: { type: Array },
    displayLabel: { type: Boolean, default: true },
    required: { type: Boolean, default: false }
  },

  data () {
    return {
      setValue: this.value,
      open: false
    };
  },

  computed: {
    selected: {
      get: function () {
        return (this.value || this.setValue || this.defaultValue);
      },

      set: function (newValue) {
        this.setValue = newValue;
      }
    },

    labelText () {
      if (this.$useTranslations) {
        if (this.required) {
          return (this.label ? this.label : this.$t(humanize(this.name, this.$useTranslations))) + "*";
        } else {
          return this.label ? this.label : this.$t(humanize(this.name, this.$useTranslations));
        }
      } else {
        if (this.required) {
          return (this.label ? this.label : humanize(this.name)) + "*";
        } else {
          return this.label ? this.label : humanize(this.name);
        }
      }
    },

    sizeOrDefault () {
      return this.multiple && "7";
    }
  },

  methods: {
    updateValue (options) {
      let values = Array.prototype.filter
        .call(options, o => o.selected)
        .map(option => option.value);

      this.$emit("input", this.multiple ? values : values[0]);
    },

    setFocus () {
      this.open = true;
    },

    mappedValues (item, index) {
      if (this.valueMap) {
        return this.valueMap[index];
      } else {
        return item;
      }
    }
  }
};
</script>
